import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import fileSaver from 'file-saver';
import Dialog from './Dialog';
import Button from '../buttons/Button';

import './ReportDialog.scss';

/**
 * Report dialog
 * @module
 * @param {bool} isOpen - Is dialog open?
 * @param {func} onClose - Function invoked on dialog close
 * @param {object} [blob] - Blob
 * @param {string} [fileName] - File name
 */
const ReportDialog = (props) => {
  const [createdUrl, setCreatedUrl] = useState(null);
  const iframeRef = useRef(null);

  useEffect(() => {
    let url = null;
    if (props.blob) {
      url = URL.createObjectURL(props.blob);
    }
    setCreatedUrl(url);

    return () => {
      if (url) {
        URL.revokeObjectURL(url);
      }
    };
  }, [props.blob]);

  const handlePrint = () => {
    if (iframeRef.current) {
      const iframeContent = iframeRef.current.contentWindow;
      if (iframeContent) {
        try {
          iframeContent.focus();
          iframeContent.print();
        } catch (e) {
          var win = window.open(createdUrl, '_blank');
          win.focus();
        }
      }
    }
  };

  const handleDownload = () => {
    if (props.blob) {
      fileSaver.saveAs(props.blob, props.fileName);
    }
  };

  return (
    createdUrl && (
      <Dialog
        isOpen={props.isOpen}
        title={'Náhľad'}
        onClose={props.onClose}
        fullscreen={true}
        className={"fullscreen-report"}
      >
        <div style={{ width: '100%', height: 'calc(100% - 45px)' }}>
          <div className="report-buttons">
            <Button
              label="Tlačiť"
              primary={true}
              icon="print"
              onClick={handlePrint}
            />
            <Button
              label="Stiahnuť dokument"
              primary={true}
              icon="download"
              onClick={handleDownload}
            />
          </div>
          {
            <iframe
              src={createdUrl + '#toolbar=0&navpanes=0'}
              width="100%"
              height="100%"
              title={props.fileName}
              ref={iframeRef}
            />
          }
        </div>
      </Dialog>
    )
  );
};

ReportDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  blob: PropTypes.object,
  fileName: PropTypes.string,
};

export default ReportDialog;